import {
    ButtonIcon,
    MConfirmation,
    CardSkeleton,
    ConfirmRequest,
    MCardOfferDetails
  } from '../../../../components';
  import { useTranslation } from 'react-i18next';
  import {
    pen,
    trash,
    confirmDelete,
  } from '../../../../assets/icons';
  import { useContext, useEffect, useState } from 'react';
  import { Navigate, useNavigate, useParams } from 'react-router-dom';
  import {
    closeOrderCar,
    getConfirmationRequest,
  } from '../../../../services/apis/order';
  import {
    confirmationOffer,
    deleteSavedOffer,
    getOfferWithRequestForCompleteRequest,
    getSavedOffer,
    updateOfferStatus,
  } from '../../../../services/apis/offer';
  import { Bounce, toast } from 'react-toastify';
  import {
    toastConfig,
    userRole,
  } from '../../../../helpers/helper';
  import { CompleteOfferContext } from '../../../../context/CompleteOfferContext';
  import './offer.css';
  import { getUserInfo } from '../../../../services/apis/user';
  const MOfferDetails = () => {
    const completeOfferContext = useContext(CompleteOfferContext);
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { id } = useParams();
    const [offer, setOffer] = useState({});
    const [loading, setLoading] = useState(false);
    const [openChooseCarModal, setOpenChooseCarModal] = useState(false);
    const [openConfirmModal, setOpenConfirmModal] = useState(false);
    const [openCompleteOfferModal, setOpenCompleteOfferModal] = useState(false);
    const [loadingUpdateAccept, setLoadingUpdateAccept] = useState(false);
    const [loadingUpdateReject, setLoadingUpdateReject] = useState(false);
    const [loadingOffers, setLoadingOffers] = useState(false);
    const [offers, setOffers] = useState([]);
    const [isOpen, setIsOpen] = useState(false);
    const [loadingConfirm, setLoadingConfirm] = useState(false);
    const [openDeleteModal, setOpenDeleteModal] = useState(false);
  
    const [openConfirmRequestModal, setOpenConfirmRequestModal] = useState(false);
    const [openPaidRequestModal, setOpenPaidRequestModal] = useState(false);
    const [confirmationRequest, setConfirmationRequest] = useState(null);
    const [confirmationId, setConfirmationId] = useState(null);
    const [hideActionModal, setHideActionModal] = useState(false);
    const [userInfo, setUserInfo] = useState(null);
  
    const handleUserInfo = async () => {
      const response = await getUserInfo();
      setUserInfo(response);
    };
  
    useEffect(() => {
      handleUserInfo();
    }, []);
  
    const loader = (type) => {
      let loaderFalse =
        type == 'accept'
          ? setLoadingUpdateAccept(false)
          : setLoadingUpdateReject(false);
      return loaderFalse;
    };
  
    useEffect(() => {
      getOfferDetails();
    }, []);
  
    const getOfferDetails = async () => {
      setLoading(true);
      const response = await getSavedOffer('', id);
      setOffer(response, setLoading(false));
    };
  
    const offerUpdateStatus = async (type) => {
      type == 'accept'
        ? setLoadingUpdateAccept(true)
        : setLoadingUpdateReject(true);
  
      let data = {
        offerId: offer.offerId,
        offerStatusId: type == 'accept' ? 1 : 2,
      };
      try {
        const response = await updateOfferStatus(data);
        toast.success(t('تم التعديل الحالة بنجاح'), toastConfig, loader(type));
      } catch (error) {
        if (error.response) {
          if (error.response.status == 400) {
            toast.error(error.response.data.message, toastConfig, loader(type));
          } else if (error.response.status == 500) {
            toast.error(error.response.data.message, toastConfig, loader(type));
          }
        }
      }
    };
  
    const toggleMenu = () => {
      setIsOpen(!isOpen);
    };
  
    const closeMenu = () => {
      setIsOpen(false);
    };
  
    const getOffersWithRequest = async () => {
      setLoadingOffers(true);
      const response = await getOfferWithRequestForCompleteRequest('', id);
      setOffers(response.data.offers, setLoadingOffers(false));
    };
  
    const confirm = () => {
      setOpenCompleteOfferModal(false);
      setOpenChooseCarModal(true);
    };
  
    const confirmRequest = async () => {
      let cars = [];
      completeOfferContext.selectedCars.forEach((carId) => {
        cars.push({ offerCarId: carId });
      });
      let data = {
        cars: cars,
      };
      try {
        const response = await confirmationOffer(data);
        setOpenChooseCarModal(false);
        setOpenConfirmModal(true);
        toast.success(t('تم تاكيد الطلب بنجاح'), toastConfig);
      } catch (error) {
        if (error.response) {
          if (error.response.status == 400) {
            toast.error(error.response.data.message, toastConfig);
          } else if (error.response.status == 500) {
            toast.error(error.response.data.message, toastConfig);
          }
        }
      }
    };
  
    const completeRequestConfirm = () => {
      confirmRequest();
    };
  
    const goToHome = () => {
      navigate('/');
    };
  
    const closeOrder = async () => {
      let data = {
        params: {
          closureMessage: 'تم الاغلاق بنجاح',
        },
      };
      const response = await closeOrderCar(data.params, id);
      getOfferDetails();
      toast.success(t('تم غلق الطلب بنجاح'), toastConfig);
    };
  
    const removeOffer = async () => {
      try {
        setLoadingConfirm(true);
        const response = await deleteSavedOffer('', id);
        navigate('/offers');
        toast.success(
          t('offerCycle.deleteOfferSuccess'),
          toastConfig,
          setLoadingConfirm(false)
        );
      } catch (error) {
        toast.error(error.response.data, toastConfig, setLoadingConfirm(false));
      }
    };
  
    const action = () => {
      setConfirmationId(offer.inProgressOrFinalizedCR?.id);
      if (offer.offerStatus == 3) {
        if (userInfo.userId == offer.userId) {
          setOpenConfirmRequestModal(
            true,
            setHideActionModal(
              true,
              getConfirmationRequestData(offer.inProgressOrFinalizedCR?.id)
            )
          );
        } else {
          setOpenConfirmRequestModal(
            true,
            setHideActionModal(
              false,
              getConfirmationRequestData(offer.inProgressOrFinalizedCR?.id)
            )
          );
        }
      } else if (offer.offerStatus == 1 || offer.offerStatus == 4) {
        if (localStorage.getItem('userRole') == 2) {
          setOpenPaidRequestModal(
            true,
            getConfirmationRequestData(offer.inProgressOrFinalizedCR?.id)
          );
        } else {
          setOpenConfirmRequestModal(
            true,
            setHideActionModal(
              true,
              getConfirmationRequestData(offer.inProgressOrFinalizedCR?.id)
            )
          );
        }
      } else if (offer.offerStatus == 5) {
        setOpenConfirmRequestModal(
          true,
          setHideActionModal(
            true,
            getConfirmationRequestData(offer.inProgressOrFinalizedCR?.id)
          )
        );
      }
    };
  
    const getConfirmationRequestData = async (confirmationId) => {
      const response = await getConfirmationRequest('', confirmationId);
      response.data.medInfo = response.data.otherUserInfo;
      response.data.medInfo.avgRating = response.data.otherUserInfo.medAvgRating;
      response.data.cars = [];
      response.data.confirmationCars.forEach((car) => {
        response.data.cars.push(car.offerCar);
      });
  
      setConfirmationRequest(response.data);
    };
  
    return (
      <div className="bg-gradient-to-b from-[#FFFFFF] to-[#D7E2FF] p-5">
        <div className="w-[90%] mr-auto ml-auto">
          <div className="flex flex-row items-center justify-between my-5">
            <div className="flex flex-row items-center">
              <div className="bg-[#3E0292] p-3 rounded-[10px] text-[#ffffff] text-[14px] font-500 flex flex-row items-center">
                <div>{t('offerDetails.details')} </div>
                <div className="px-2">:</div>
                <div>#{offer.id}</div>
              </div>
            </div>
            <div className="flex min600:flex-row max600:flex-col max800:flex-col items-center">
                  {userRole == 3 && !offer?.inProgressOrFinalizedCR?.id && offer.offerStatus!=4 && offer.offerStatus!=2 ? (
                    <>
                      <ButtonIcon
                        dark={true}
                        title={t('offerCycle.editOffer')}
                        icon={pen}
                        onClick={() => navigate(`/offers/${id}/edit`)}
                      />
                      <ButtonIcon
                        dark={false}
                        title={t('offerCycle.deleteOffer')}
                        className="bg-[#FD2828] border-[#FD2828] mx-2 max600:mt-3 max800:mt-3"
                        icon={trash}
                        onClick={() => setOpenDeleteModal(true)}
                      />
                    </>
                  ) : null}
  
              <MConfirmation
                loading={loadingConfirm}
                openModal={openDeleteModal}
                showFooter={true}
                setOpenModal={setOpenDeleteModal}
                title={t('هل متاكد من حذف العرض')}
                content={
                  <div className="flex justify-center items-center">
                    <img src={confirmDelete} />
                  </div>
                }
                confirm={removeOffer}
              />
  
              <div>
              </div>
            </div>
          </div>
              {loading ? (
                <CardSkeleton number={1} height={'500px'} />
              ) : (
                  <MCardOfferDetails
                    offer={offer}
                    key={id}
                    carOffer={offer.car}
                  />
              )}
        </div>
  
        {/* details offer */}
        <MConfirmation
          loading={loading}
          openModal={openConfirmRequestModal}
          showFooter={hideActionModal ? false : true}
          setOpenModal={setOpenConfirmRequestModal}
          title={t('completeRequest.completeRequest')}
          content={
            <ConfirmRequest
              hideActionModal={hideActionModal}
              offer={confirmationRequest}
            />
          }
          confirm={confirmRequest}
        />
      </div>
    );
  };
  export default MOfferDetails;
  